// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__30n4-","fileBtn":"File_fileBtn__mVYt1","closeBtn":"File_closeBtn__3Xg3E","fileSelected":"File_fileSelected__3mad4","disabled":"File_disabled__3pzLP"};